import React from 'react';
import {Login} from '../components/login';
import {Container} from '../components/container';

export function LoginScreen() {
    return (
        <div style={{minHeight: '100vh', display: 'flex'}}>
            <Container style={{margin: 'auto'}}>
                <Login/>
            </Container>
        </div>
    );
}